export function ContactsHover() {
    const $block = $(".contacts-section").find(".contact-block");
    const BODY = $("body");
    const WIN = $(window);
    const point = 1200;
    setEvents();
    function setEvents() {
        $block.hover(
            function () {
                if (BODY.hasClass("no-touch") && WIN.width() > point) {
                    $(this).css("width", "55%");
                }
            },
            function () {
                $(this).removeAttr("style");
            }
        );
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/ContactsHover.js